import { render, staticRenderFns } from "./barList.vue?vue&type=template&id=45e30b64&scoped=true"
import script from "./barList.vue?vue&type=script&lang=js"
export * from "./barList.vue?vue&type=script&lang=js"
import style0 from "./barList.vue?vue&type=style&index=0&id=45e30b64&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45e30b64",
  null
  
)

export default component.exports